import { ServiceBase } from "../core";

export type ExternalBondRecordRequest = {
  obligation_id: string;
  bond_amount: number;

  is_business: boolean;

  // business principals
  principal_name?: string;
  principal_dba?: string;

  // individual principals
  principal_first_name?: string;
  principal_middle_name?: string;
  principal_last_name?: string;
  principal_suffix?: string;

  principal_address1: string;
  principal_city: string;
  principal_state: string;
  principal_zip: string;

  principal_email?: string;
  principal_phone?: string;

  effective_date: string;
  expiration_date: string;

  state: string;

  agreed_to_terms_and_conditions?: boolean;
  /** Required by the API whenever consent is given, as YYYY-MM-DD. */
  tc_version?: string;

  form_specific_fields: { [key: string]: string };
};

export type ExternalBondRecord = {
  salesforce_id: string;
  salesforce_account_id: string;
  record_group_code: string;
  access_key: string;

  external_order_id: string;

  status_name: string;

  product_id: string;
  product_name: string;
  obligee_name: string;
  principal_name_on_bond: string;

  bond_number: string | null;
  bond_penalty_amount: number | null;
  /** In dollars, unlike the cents an external product quotes in. */
  bond_premium_amount: number | null;

  effective_date: string | null;
  expiration_date: string | null;
};

export type ExternalBondRecordResponse = {
  data: ExternalBondRecord;
};

class ExternalBondRecordsService extends ServiceBase {
  public static submitOrder(
    payload: ExternalBondRecordRequest
  ): Promise<ExternalBondRecordResponse> {
    return ServiceBase.callApi({
      method: "POST",
      url: "/external-bond-records",
      data: payload,
    });
  }
}

export default ExternalBondRecordsService;
